<template>
    <a
      href="#"
      @click="addItem"
      class="dropdown-item"
      rel="nofollow"
      :product_id="this.product_idLocal"
      :data-price="this.priceLocal"
      :data-variant_id="this.variant_idLocal"
    >{{this.attribute_valueLocal}}</a>
</template>

<script>
    export default {
        name: "cart-add-variant-button",
        props: ['attribute_value','product_id','price','variant_id'],
        data() {
            return {
                attribute_valueLocal: this.attribute_value,
                product_idLocal: this.product_id,
                priceLocal: this.price,
                variant_idLocal: this.variant_id,
            }
        },
        methods: {
            addItem(event) {
                event.preventDefault();
                this.$store.dispatch(
                    'addProduct',
                    {
                        product_id: this.product_idLocal,
                        qty: 1,
                        variant_id: this.variant_idLocal
                    })
            }
        }
    }
</script>

<style scoped>
</style>